import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPut, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';

interface Vars {
  appointmentId: string;
  issueSummary: string;
}

/**
 * PUT /jobs/:id/appointments/:appointmentId — persist the visit's issue summary.
 * The backend update is a guarded partial (`if (dto.x !== undefined)`), so sending
 * only `issueSummary` leaves every other appointment field untouched.
 */
export function useUpdateIssueSummary(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, Vars>({
    mutationFn: ({ appointmentId, issueSummary }) =>
      apiPut(operationsClient, jobEndpoints.appointment(jobId, appointmentId), { issueSummary }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(jobId) });
      toast.success('Issue summary saved');
    },
  });
}
